import type { Locale } from '@/i18n/types'

export const SURVEY_NOTICE_PATH = '/feedback-notice'
export const SURVEY_NOTICE_VERSION = 'survey-notice-2026-10-28'

export const surveyNoticeHref = (locale: Locale): string => `${SURVEY_NOTICE_PATH}?lang=${locale}`
